<template>
  <div class="early-settlement-banner">
    <img src="@/assets/images/early-settlement-banner.png" alt="Erken Ödeme Talebi">
  </div>
</template>

<script>
export default {
  name: "EarlySettlementBanner",
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.early-settlement-banner {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
  }
}
</style>
